import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = ["stroke"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'CalendarIcon',
    props: {
        color: {
            type: String,
            required: true
        }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M4.6665 8H20.6665M4.6665 8V16.8002C4.6665 17.9203 4.6665 18.4801 4.88449 18.9079C5.07624 19.2842 5.38198 19.5905 5.7583 19.7822C6.18571 20 6.7455 20 7.86341 20H17.4696C18.5875 20 19.1465 20 19.5739 19.7822C19.9502 19.5905 20.257 19.2842 20.4487 18.9079C20.6665 18.4805 20.6665 17.9215 20.6665 16.8036V8M4.6665 8V7.2002C4.6665 6.08009 4.6665 5.51962 4.88449 5.0918C5.07624 4.71547 5.38198 4.40973 5.7583 4.21799C6.18612 4 6.74659 4 7.8667 4H8.6665M20.6665 8V7.19691C20.6665 6.07899 20.6665 5.5192 20.4487 5.0918C20.257 4.71547 19.9502 4.40973 19.5739 4.21799C19.1461 4 18.5868 4 17.4667 4H16.6665M16.6665 2V4M16.6665 4H8.6665M8.6665 2V4",
                    stroke: __props.color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8, _hoisted_2)
            ]));
        };
    }
});
